export default "__VITE_ASSET__35KXZNIJ__"